var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditContained = function SvgEditContained(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.049 3.352h-6a3.6 3.6 0 0 0-3.6 3.6v12a3.6 3.6 0 0 0 3.6 3.6h12a3.6 3.6 0 0 0 3.6-3.6v-6m-13.2 3.6 4.366-.88a1.2 1.2 0 0 0 .611-.328l9.774-9.78a1.2 1.2 0 0 0 0-1.697L20.128 1.8a1.2 1.2 0 0 0-1.697.001l-9.775 9.78a1.2 1.2 0 0 0-.327.61l-.881 4.362Z"
  })));
};
export default SvgEditContained;